<app-dialog
    class="dialog"
    [header]="'Waste / Destroy'"
    subHeader="Wasting / Destroying inventory requires a witness by law"
    subheaderIconName="icon-warning-red"
    [show]="true"
    [hasControls]="true"
    [saveBtnText]="'Waste / Destroy'"
    [saveBtnMinWidth]="145"
    [hideControlsDivider]="true"
    [minWidth]="1200"
    (save)="submitForm()"
    (cancel)="cancel.emit()"
    (onCancelKeyDown)="nameOfDestruction.focusInput()"
    (onSubmitKeyDown)="nameOfDestruction.focusInput()"
    #dialog
>
    <div [formGroup]="form" >
        <div class="controls-container">
            <div class="flex space-x-4 mb-5">
                <app-input class="destruction-name"
                    label="Name of Destruction | Custom Lot #"
                    formControlName="nameOfDestruction"
                    placeholder="Spring 2024 Destruction"
                    [symbolsLeftCounter]="true"
                    [maxLength]="100"
                    [autofocus]="true"
                    #nameOfDestruction
                ></app-input>
                <app-datepicker-input [tabInd]="0"
                    class="ml-[8px]"
                    label="Date/Time"
                    pickerType="both"
                    formControlName="transactionDateDisplayValue"
                    (dateTimeChange)="dateTimeChanged($event)"
                    (inputTabKeyDown)="method.focusInput()"
                    [dateMax]="now()"
                    calendarPosition="right"
                    #transactionDatePicker>
                </app-datepicker-input>
            </div>
            <div class="flex space-x-4 mb-5">
                <app-input label="Method of Destruction" class="destruction-method"
                    formControlName="methodOfDestruction"
                    placeholder="Drugs were dropped at a drug take back location"
                    #method
                ></app-input>
                <app-autocomplete 
                    class="autocomplete"
                    [data]="placesOfDestruction$ | async" searchKeyword="name"
                    [control]="form.controls.placeOfDestructionId"
                    label="Place of Destruction"
                    placeholder="Pharmacy"
                    (itemAdded)="addPlaceOfDestruction($event)"
                    #autocomplete
                >
                </app-autocomplete>
            </div>
        </div>
        <table class="table-primary">
            <thead>
                <tr>
                    <th class="text-left drug" scope="col">
                        Drug
                    </th>
                    <th class="text-left location" scope="col" *ngIf="inventoryLocationsEnabled$ | async">
                        From Location
                    </th>
                    <th class="text-right starting" scope="col">
                        Starting
                    </th>
                    <th class="text-right count" scope="col">
                        Count
                    </th>
                    <th class="text-right on-hand !pl-0" scope="col">
                        On-Hand
                    </th>
                    <th class="controls"></th>
                </tr>
            </thead>
            <tbody cdk-scrollable>
                <tr class="table-row">
                    <td class="text-left drug" >
                        <div class="heading">
                            {{ndcToWaste?.friendlyName}} 
                        </div>
                        <div class="secondary flex">
                            {{ndcToWaste?.packageNdc11Digits}}
                        </div>
                    </td>
                    <td class="location" *ngIf="inventoryLocationsEnabled$ | async"> 
                        {{ndcToWaste?.locationName}}
                    </td>
                    <td class="text-right starting">{{ndcToWaste?.onHand | number}}</td>
                    <td class="!pl-2 count">
                        <app-input
                            class="block"
                            formControlName="addedQuantity"
                            [type]="'number'"
                            customClasses="-mr-64"
                            [showErrors]="false"
                            textAlign="right"
                            #addedQuantityInput
                            (keyupEnter)="addedQtyTabbedEntered($event)"
                            (keydownTab)="addedQtyTabbedEntered($event)"
                        ></app-input>
                    </td>
                    <td class="text-right on-hand">
                        {{onHand}}
                    </td>
                    <td class="controls text-right !pr-4">
                     <div class="flex space-x-5">
                        <app-add-note class="block cursor-pointer z-10"
                            [friendlyName]="ndcToWaste?.friendlyName"
                            [note]="form.controls.note?.value"
                            (deleted)="removeNote()"
                            (submitted)="saveAddedNote($event)">
                        </app-add-note>
                     </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</app-dialog>